'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dPage$0024 from "./presto.-Agent-Page$.js";
import * as $j_presto$002e$002dAudit$002dPage$0024 from "./presto.-Audit-Page$.js";
import * as $j_presto$002e$002dConfig$002dPage$0024 from "./presto.-Config-Page$.js";
import * as $j_presto$002e$002dCreate$002dPolicy$002dPage$0024 from "./presto.-Create-Policy-Page$.js";
import * as $j_presto$002e$002dCredentials$002dUsage$002dPage$0024 from "./presto.-Credentials-Usage-Page$.js";
import * as $j_presto$002e$002dDashboard$002dPage$0024 from "./presto.-Dashboard-Page$.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage from "./presto.-Edit-Group-Site-Page.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage from "./presto.-Edit-Grouping-Page.js";
import * as $j_presto$002e$002dEdit$002dPolicy$002dPage from "./presto.-Edit-Policy-Page.js";
import * as $j_presto$002e$002dEnvelope$002dDetail$002dPage from "./presto.-Envelope-Detail-Page.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024 from "./presto.-Freemium2-F-A-Add-Page$.js";
import * as $j_presto$002e$002dHome$002dPage$0024 from "./presto.-Home-Page$.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage from "./presto.-List-Account-Users-Page.js";
import * as $j_presto$002e$002dList$002dAccounts$002dPage$0024 from "./presto.-List-Accounts-Page$.js";
import * as $j_presto$002e$002dList$002dCredentials$002dPage from "./presto.-List-Credentials-Page.js";
import * as $j_presto$002e$002dList$002dDirectives$002dPage from "./presto.-List-Directives-Page.js";
import * as $j_presto$002e$002dList$002dEnvelopes$002dPage$0024 from "./presto.-List-Envelopes-Page$.js";
import * as $j_presto$002e$002dList$002dGroupings$0024 from "./presto.-List-Groupings$.js";
import * as $j_presto$002e$002dList$002dGroups$002dPage$0024 from "./presto.-List-Groups-Page$.js";
import * as $j_presto$002e$002dList$002dPolicies$002dPage$0024 from "./presto.-List-Policies-Page$.js";
import * as $j_presto$002e$002dList$002dProxies$002dPage$0024 from "./presto.-List-Proxies-Page$.js";
import * as $j_presto$002e$002dList$002dRestricted$002dDomains$0024 from "./presto.-List-Restricted-Domains$.js";
import * as $j_presto$002e$002dList$002dRules$002dPage$0024 from "./presto.-List-Rules-Page$.js";
import * as $j_presto$002e$002dList$002dSites$002dPage$0024 from "./presto.-List-Sites-Page$.js";
import * as $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth from "./presto.-List-Two-Factor-Auth.js";
import * as $j_presto$002e$002dList$002dUsers$002dPage$0024 from "./presto.-List-Users-Page$.js";
import * as $j_presto$002e$002dLogin$002dPage$0024 from "./presto.-Login-Page$.js";
import * as $j_presto$002e$002dOystr$002dAdmin$002dPage$0024 from "./presto.-Oystr-Admin-Page$.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage from "./presto.-Register-Directive-Page.js";
import * as $j_presto$002e$002dRegister$002dPage$0024 from "./presto.-Register-Page$.js";
import * as $j_presto$002e$002dSign$002dDocument$002dPage$0024 from "./presto.-Sign-Document-Page$.js";
import * as $j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024 from "./presto.-Signed-Documents-History-Page$.js";
import * as $j_presto$002e$002dSigning$002dPage from "./presto.-Signing-Page.js";
import * as $j_presto$002e$002dTest$002dPage$0024 from "./presto.-Test-Page$.js";
import * as $j_presto$002e$002dUnknown$002dPage from "./presto.-Unknown-Page.js";
import * as $j_presto$002e$002dValidation$002dPage from "./presto.-Validation-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$38() {
}
export { $c_Lpresto_PrestoRouter$$anon$38 as $c_Lpresto_PrestoRouter$$anon$38 };
$p = $c_Lpresto_PrestoRouter$$anon$38.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$38;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$38() {
}
export { $h_Lpresto_PrestoRouter$$anon$38 as $h_Lpresto_PrestoRouter$$anon$38 };
$h_Lpresto_PrestoRouter$$anon$38.prototype = $p;
$p.cNF = (function(x$0) {
  if ((x$0 === $j_presto$002e$002dAgent$002dPage$0024.$m_Lpresto_AgentPage$())) {
    return 0;
  }
  if ((x$0 === $j_presto$002e$002dAudit$002dPage$0024.$m_Lpresto_AuditPage$())) {
    return 1;
  }
  if ((x$0 === $j_presto$002e$002dLogin$002dPage$0024.$m_Lpresto_LoginPage$())) {
    return 2;
  }
  if ((x$0 === $j_presto$002e$002dRegister$002dPage$0024.$m_Lpresto_RegisterPage$())) {
    return 3;
  }
  if ((x$0 === $j_presto$002e$002dHome$002dPage$0024.$m_Lpresto_HomePage$())) {
    return 4;
  }
  if ((x$0 === $j_presto$002e$002dCreate$002dPolicy$002dPage$0024.$m_Lpresto_CreatePolicyPage$())) {
    return 5;
  }
  if ((x$0 === $j_presto$002e$002dCredentials$002dUsage$002dPage$0024.$m_Lpresto_CredentialsUsagePage$())) {
    return 6;
  }
  if ((x$0 instanceof $j_presto$002e$002dEdit$002dGrouping$002dPage.$c_Lpresto_EditGroupingPage)) {
    return 7;
  }
  if ((x$0 instanceof $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage.$c_Lpresto_EditGroupSitePage)) {
    return 8;
  }
  if ((x$0 instanceof $j_presto$002e$002dEdit$002dPolicy$002dPage.$c_Lpresto_EditPolicyPage)) {
    return 9;
  }
  if ((x$0 instanceof $j_presto$002e$002dList$002dCredentials$002dPage.$c_Lpresto_ListCredentialsPage)) {
    return 10;
  }
  if ((x$0 === $j_presto$002e$002dList$002dGroupings$0024.$m_Lpresto_ListGroupings$())) {
    return 11;
  }
  if ((x$0 instanceof $j_presto$002e$002dList$002dDirectives$002dPage.$c_Lpresto_ListDirectivesPage)) {
    return 12;
  }
  if ((x$0 instanceof $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth.$c_Lpresto_ListTwoFactorAuth)) {
    return 13;
  }
  if ((x$0 === $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024.$m_Lpresto_Freemium2FAAddPage$())) {
    return 14;
  }
  if ((x$0 === $j_presto$002e$002dList$002dAccounts$002dPage$0024.$m_Lpresto_ListAccountsPage$())) {
    return 15;
  }
  if ((x$0 instanceof $j_presto$002e$002dList$002dAccount$002dUsers$002dPage.$c_Lpresto_ListAccountUsersPage)) {
    return 16;
  }
  if ((x$0 === $j_presto$002e$002dList$002dGroups$002dPage$0024.$m_Lpresto_ListGroupsPage$())) {
    return 17;
  }
  if ((x$0 === $j_presto$002e$002dList$002dUsers$002dPage$0024.$m_Lpresto_ListUsersPage$())) {
    return 18;
  }
  if ((x$0 === $j_presto$002e$002dList$002dPolicies$002dPage$0024.$m_Lpresto_ListPoliciesPage$())) {
    return 19;
  }
  if ((x$0 === $j_presto$002e$002dList$002dRestricted$002dDomains$0024.$m_Lpresto_ListRestrictedDomains$())) {
    return 20;
  }
  if ((x$0 === $j_presto$002e$002dList$002dProxies$002dPage$0024.$m_Lpresto_ListProxiesPage$())) {
    return 21;
  }
  if ((x$0 === $j_presto$002e$002dList$002dRules$002dPage$0024.$m_Lpresto_ListRulesPage$())) {
    return 22;
  }
  if ((x$0 === $j_presto$002e$002dList$002dSites$002dPage$0024.$m_Lpresto_ListSitesPage$())) {
    return 23;
  }
  if ((x$0 === $j_presto$002e$002dOystr$002dAdmin$002dPage$0024.$m_Lpresto_OystrAdminPage$())) {
    return 24;
  }
  if ((x$0 instanceof $j_presto$002e$002dRegister$002dDirective$002dPage.$c_Lpresto_RegisterDirectivePage)) {
    return 25;
  }
  if ((x$0 === $j_presto$002e$002dTest$002dPage$0024.$m_Lpresto_TestPage$())) {
    return 26;
  }
  if ((x$0 === $j_presto$002e$002dConfig$002dPage$0024.$m_Lpresto_ConfigPage$())) {
    return 27;
  }
  if ((x$0 === $j_presto$002e$002dSign$002dDocument$002dPage$0024.$m_Lpresto_SignDocumentPage$())) {
    return 28;
  }
  if ((x$0 === $j_presto$002e$002dDashboard$002dPage$0024.$m_Lpresto_DashboardPage$())) {
    return 29;
  }
  if ((x$0 === $j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024.$m_Lpresto_SignedDocumentsHistoryPage$())) {
    return 30;
  }
  if ((x$0 === $j_presto$002e$002dList$002dEnvelopes$002dPage$0024.$m_Lpresto_ListEnvelopesPage$())) {
    return 31;
  }
  if ((x$0 instanceof $j_presto$002e$002dEnvelope$002dDetail$002dPage.$c_Lpresto_EnvelopeDetailPage)) {
    return 32;
  }
  if ((x$0 instanceof $j_presto$002e$002dSigning$002dPage.$c_Lpresto_SigningPage)) {
    return 33;
  }
  if ((x$0 instanceof $j_presto$002e$002dValidation$002dPage.$c_Lpresto_ValidationPage)) {
    return 34;
  }
  if ((x$0 instanceof $j_presto$002e$002dUnknown$002dPage.$c_Lpresto_UnknownPage)) {
    return 35;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_PrestoRouter$$anon$38 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$38, "presto.PrestoRouter$$anon$38", ({
  Oc: 1,
  a: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$38 as $d_Lpresto_PrestoRouter$$anon$38 };
//# sourceMappingURL=presto.-Presto-Router$$anon$38.js.map
